module.exports = __webpack_public_path__ + "static/media/icon_calendar_disable.26a0332e.svg";